<template>
	<div class="content scroll-container">
		<!-- 联系我们 -->
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>
			</div>
		</transition>
		<div class="custom-banner wow animate__animated animate__fadeInUp animate__delay-0.3s">
			<img src="../../static/images/contact/banner2.png" v-show="currlangs == 0" >
			<img src="../../static/images/contact/eng/1.png" v-show="currlangs == 1" >
			<img src="../../static/images/contact/eng/2.png" v-show="currlangs == 2" >
		</div>
		<div class="container pa-content">
			<div class="contact-box">
				<div class="contact-box-wel">
					<el-row>
						<el-col :xs="24" :md="3">
							<img src="../../static/images/contact/kefu.png"></img>
						</el-col>
						<el-col :xs="24" :md="21">
							<div class="wel-text">
								<h4>{{ langs.contact1 }}：</h4>
								<div>{{ langs.contact2 }}</div>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="contact-1">
					<div class="contact-1-title">{{ langs.contact3 }}</div>
					<div class="contact-1-list">
						<div>{{ langs.contact4 }}：https://szupus.1688.com <a href="https://szupus.1688.com" target="_blank" style="color:#009688;">{{ langs.contact5 }}</a></div>
						<div>
              {{ langs.contact6 }}：0755-88849978
              <span style="margin-left:20px;">{{ langs.footer12 }}：801</span>
            </div>
						<div>{{ langs.contact7 }}：13751007289</div>
						<div>{{ langs.contact8 }}：0755-89915369</div>
						<div>{{ langs.contact9 }}：{{ langs.footer10 }}</div>
					</div>
				</div>
				<div class="contact-2 contact-map">
					<div id="map" class="map"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	import BMap from 'BMap'
	export default{
		data() {
			return {
				showLoading: true,

				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh,
			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoading = false;
			}, 500)
		},
		mounted() {
			let _this = this;

			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}

			let addressTitle = _this.langs.contact11;
			let address = _this.langs.contact10;

			var map = new BMap.Map('map');
			var point = new BMap.Point(114.238928, 22.70246);
			map.centerAndZoom(point, 18);
			map.enableScrollWheelZoom(true);

			var myIcon = new BMap.Icon("http://api.map.baidu.com/img/markers.png", new BMap.Size(45, 27), {
				offset: new BMap.Size(30, 50), // 指定定位位置
				imageOffset: new BMap.Size(22, 0) // 设置图片偏移
			});

			var marker = new BMap.Marker(point, {
			    enableDragging: true,
					icon:myIcon
			});
			map.addOverlay(marker);
			var opts = {
			  width: 200,
			  height: 100,
			  title: addressTitle,
			};
			var infoWindow = new BMap.InfoWindow(
			  address,
			  opts
			);
			map.openInfoWindow(infoWindow, point); // 开启信息窗口
			// 点标记添加点击事件
			marker.addEventListener("click", function () {
			  map.openInfoWindow(infoWindow, point); // 开启信息窗口
			});
		},
		methods: {

		}
	}
</script>

<style scoped>
	.content{
		background: #eee;
	}
	.contact-box{
		display: inline-block;
		/* width: 100%; */
		min-height: 500px;
		margin: 40px 0px;
		background-color: #fff;
		padding: 30px 50px;
	}
	.contact-box-wel{
		width: 100%;
		display: inline-block;
	}
	.contact-box-wel img{
		width: auto;
	}
	.wel-text{
		display: inline-block;
	}
	.wel-text h4{
		font-size: 16px;
		margin: 20px 0px 12px;
	}
	.wel-text div{
		margin-left: 30px;
	}
	.contact-1-title{
		margin: 40px 0px 15px;
		font-size: 18px;
	}
	.contact-1-title b{
		font-weight: 400;
	}
	.contact-1-list div{
		padding: 5px 0px;
	}
	.contact-map{
		overflow: hidden;
		height: 400px;
		margin: 50px 0px 120px;
	}
	.contact-map #map{
		overflow: unset!important;
		height: 100%;
	}

	.contact-map img {
	  max-width: inherit;
	}
	@media screen and (max-width:768px) {
		.contact-box{
			padding: 30px 12px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/contactus.vue